import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';

const Inspiration = () => {
  const navigate = useNavigate();

  const galleries = [
    {
      slug: 'modern-minimalist',
      title: "Modern Minimalist Living",
      image: "https://images.unsplash.com/photo-1705321963943-de94bb3f0dd3?q=85&w=800",
      description: "Clean lines and functional beauty"
    },
    {
      slug: 'luxury-bedroom',
      title: "Luxury Bedroom Retreats",
      image: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?q=85&w=800",
      description: "Comfort meets elegance"
    },
    {
      slug: 'contemporary-kitchen',
      title: "Contemporary Kitchens",
      image: "https://images.unsplash.com/photo-1556911220-bff31c812dba?q=85&w=800",
      description: "Where function meets style"
    },
    {
      slug: 'zen-bathroom',
      title: "Zen Bathrooms",
      image: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?q=85&w=800",
      description: "Spa-like serenity at home"
    },
    {
      slug: 'home-office',
      title: "Home Office Spaces",
      image: "https://images.unsplash.com/photo-1484154218962-a197022b5858?q=85&w=800",
      description: "Productivity with style"
    },
    {
      slug: 'outdoor-living',
      title: "Outdoor Living",
      image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=85&w=800",
      description: "Extend your living space"
    }
  ];

  return (
    <div className="min-h-screen bg-white py-32" data-testid="inspiration-page">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold mb-4" data-testid="inspiration-title">Design Inspiration</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore stunning interiors and discover ideas for your dream space. Get inspired by our curated collection of design excellence.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {galleries.map((item, idx) => (
            <Link 
              key={idx} 
              to={`/inspiration/${item.slug}`}
              className="group cursor-pointer" 
              data-testid={`inspiration-card-${idx}`}
            >
              <div className="relative overflow-hidden mb-4 h-80 rounded-xl">
                <img loading="lazy" decoding="async" 
                  src={item.image} 
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition-all duration-300" />
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <h3 className="text-2xl font-bold mb-2">{item.title}</h3>
                  <p className="text-sm text-gray-200">{item.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="bg-[#F5F5F0] p-12 text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Transform Your Space?</h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            Get a personalized AI-powered cost estimate for your interior design project. It takes less than 2 minutes.
          </p>
          <Button 
            size="lg"
            className="rounded-none bg-primary px-12 py-6 text-lg"
            onClick={() => navigate('/interior-design')}
            data-testid="get-quote-cta"
          >
            Get Free Quote <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Inspiration;